<template>
  <CbModal @close="$closeDialog">
    <div class="rule-dialog">
      <div class="wrapper">
        <div class="title">
          <img src="https://aliimg.changba.com/!/activity2023/come_sing_with_me/title_rule.png" alt="活动规则标题" />
        </div>
        <div class="content">
          <div class="scroll-area">
            <CbRichTextRender :act-id="actId" content-id="d42a310e-c935-4be0-b16f-df5b06067cf0" />
          </div>
        </div>
      </div>
    </div>
  </CbModal>
</template>

<script>
import { actId } from "../config";
export default {
  name: "RuleDialog",
  data() {
    return {
      actId,
    };
  },
};
</script>

<style lang="scss" scoped>
.rule-dialog {
  .wrapper {
    position: relative;
    .title {
      position: absolute;
      top: -38px;
      left: 0;
      text-align: center;
      width: 100%;
      z-index: 10;
      img {
        width: 370px;
        height: 75px;
      }
    }
    .content {
      font-size: 22px;
      color: #e1bfff;
      width: 625px;
      height: 810px;
      background: #7c23f1 linear-gradient(179deg, #4e0893 0%, #8d46f2 100%);
      border: 3px solid #e1bfff;
      border-radius: 16px;
      padding: 80px 51px 40px;
    }
    .scroll-area {
      height: 100%;
      overflow-y: scroll;
    }
    .rule-item {
      margin-bottom: 18px;
      .rule-title {
        font-size: 26px;
        line-height: 40px;
        font-weight: 600;
      }
      .rule-desc {
        line-height: 32px;
      }
    }
  }
}
</style>
